import { Link } from '@inertiajs/react';
import useTranslation from '@backend/hooks/use-translation';

interface AuthLayoutProps {
    children: React.ReactNode;
    name?: string;
    title?: string;
    description?: string;
}

export default function AuthSimpleLayout({ children, title, description }: AuthLayoutProps) {
    const { __ } = useTranslation();

    return (
        <div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
            <div className="w-full max-w-sm">
                <div className="flex flex-col gap-8">
                    <div className="flex flex-col items-center gap-4">
                        { route().has('homepage') && (
                            <a href={route('homepage')} className="flex flex-col items-center gap-2 mb-4">
                                <img src="/storage/images/medialniolympiada-logo.svg" width="145" height="40" alt="Mediální olympiáda logo" />
                            </a>
                        )}

                        <div className="space-y-2 text-center">
                            <h1 className="text-xl font-medium">{ __(title) }</h1>
                            <p className="text-muted-foreground text-center text-sm">{ __(description) }</p>
                        </div>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
}
